import React, { useCallback, useEffect, useState } from 'react'
import AssetShape from './AssetShape'
import { CHROMA_MAX_OPACITY } from '../../../../constant'
import { init, startProcessing } from '../../useImageChromaKey'

const ImageAssetOverlay = React.memo(({
  asset,
  index,
  size,
  scale,
  boundingRect,
  extSourcePos,
  extSourceSize,
  extSourceRotation,
  onChange,
}) => {
  const {
    isChromaKeyEnabled,
    chromaKeyColor,
    similarity,
    smoothness,
    spillReduction,
    chromaKeyOpacity,
  } = asset?.settings || {}
  const [ source, setSource ] = useState()

  const setImage = useCallback(
    image => {
      if (__CFG__.IS_CHROMAKEY_ENABLED && isChromaKeyEnabled) {
        const canvas = document.createElement('canvas')
        canvas.width = size.width
        canvas.height = size.height

        const gl = canvas.getContext('webgl', { premultipliedAlpha: false })

        if (!gl) throw new Error('Could not initialize webgl')

        const wgl = { gl, prog: init(gl) }

        const getConfig = () => {
          const { r, g, b } = chromaKeyColor
          return {
            keycolor: [ r / 255, g / 255, b / 255 ],
            similarity: similarity / 1000,
            smoothness: smoothness / 1000,
            spill: spillReduction / 1000,
            opacity: chromaKeyOpacity / CHROMA_MAX_OPACITY,
          }
        }

        startProcessing(image, canvas, wgl, getConfig)
        setSource(canvas)
      } else {
        setSource(image)
      }

      onChange && onChange(asset.id)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ isChromaKeyEnabled, chromaKeyColor, similarity, smoothness, spillReduction, chromaKeyOpacity ]
  )

  useEffect(() => {
    if (asset.url) {
      const img = new Image()
      img.onload = () => setImage(img)
      img.crossOrigin = 'Anonymous'
      img.src = asset.url

      return () => {
        img.onload = () => undefined
      }
    }

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ asset.settings ])

  return (
    <If condition={source}>
      <AssetShape
        asset={asset}
        index={index}
        size={size}
        scale={scale}
        source={source}
        settings={asset.settings}
        outline={{ ...asset.settings }}
        boundingRect={boundingRect}
        extSourcePos={extSourcePos}
        extSourceSize={extSourceSize}
        extSourceRotation={extSourceRotation}
        onChange={onChange}
      />
    </If>
  )
})

export default ImageAssetOverlay
